import { render, staticRenderFns } from "./joinInterview.vue?vue&type=template&id=8fa149a8&scoped=true&"
import script from "./joinInterview.vue?vue&type=script&lang=js&"
export * from "./joinInterview.vue?vue&type=script&lang=js&"
import style0 from "./joinInterview.vue?vue&type=style&index=0&id=8fa149a8&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../opt/deploy_node_modules/ailaworld/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fa149a8",
  null
  
)

export default component.exports